import { render, staticRenderFns } from "./blockView.vue?vue&type=template&id=19951092&scoped=true&"
import script from "./blockView.vue?vue&type=script&lang=ts&"
export * from "./blockView.vue?vue&type=script&lang=ts&"
import style0 from "./blockView.vue?vue&type=style&index=0&id=19951092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19951092",
  null
  
)

export default component.exports